// extracted by mini-css-extract-plugin
export default {"icon":"Password_icon__gbF0h","div":"Password_div__YjYsx"};